import { Card, CardBody } from '@change/ds-core-ui/Card';
import { Spinner } from '@change/ds-core-ui/Spinner';
import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';

/** Shown in place of the decision-maker cards while inference is running. */
export const DecisionMakersLoading: React.FC<EmptyProps> = () => (
	<div data-qa="decision-makers-loading">
		<Card className="bg-background-base w-full [--card-padding:1.5rem]">
			<CardBody className="flex items-center gap-2">
				<Spinner className="size-4" />
				<Text className="text-typography-weak">
					<Translate value="corgi.start_a_petition.decision_makers.loading" />
				</Text>
			</CardBody>
		</Card>
	</div>
);
